function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPiezo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61.758 80.166",
    width: 45,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1, 0, 0, 1, -75.168228, -103.834076)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.31139946
    },
    id: "path630",
    cx: 106.07923,
    cy: 135.50124,
    rx: 23.36812,
    ry: 24.166615
  }), /*#__PURE__*/React.createElement("g", {
    id: "g585",
    transform: "matrix(1.2011179,0,0,1.1966959,-108.44106,-190.17404)",
    style: {
      fill: "#143682",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#143682",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    },
    d: "m 177.18494,308.62307 c -0.37986,-0.20645 -1.18003,-1.18395 -1.77816,-2.17221 -1.55918,-2.57619 -3.28807,-4.66229 -8.3613,-10.08889 -5.14299,-5.50121 -7.091,-8.09086 -8.88857,-11.81629 -1.99051,-4.12531 -2.49415,-6.51818 -2.47809,-11.77396 0.0154,-5.02587 0.40009,-6.89426 2.21897,-10.77563 2.95125,-6.2978 8.26196,-10.75035 14.95072,-12.53482 2.78595,-0.74326 7.87851,-0.8257 10.60496,-0.17169 11.81843,2.83498 19.25365,13.92401 17.84507,26.61448 -0.82265,7.41157 -3.50157,12.21879 -11.49365,20.62492 -4.19968,4.41725 -6.84445,7.63334 -8.24074,10.02089 -1.36149,2.32803 -2.72374,2.97295 -4.37921,2.0732 z m 5.71322,-20.14542 c 5.85491,-1.5036 10.56563,-6.24065 12.19817,-12.26635 0.62016,-2.28901 0.62239,-6.43594 0.005,-8.70834 -1.64337,-6.04555 -6.45493,-10.75802 -12.5952,-12.33582 -2.3644,-0.60755 -7.13446,-0.41648 -9.45118,0.37857 -5.0802,1.74344 -9.09561,5.79976 -10.95614,11.06775 -0.7964,2.25497 -0.97263,6.63161 -0.36759,9.12898 1.64617,6.79474 7.31322,12.06351 14.16032,13.16514 1.82168,0.29308 4.93554,0.10203 7.00694,-0.42993 z M 171.12872,276.2113 v -9.525 h -3.57187 -3.57188 v -1.05833 -1.05834 h 4.63021 4.63021 v 4.49792 c 0,2.47385 0.10448,4.49792 0.23219,4.49792 0.1277,0 0.38256,-0.1812 0.56635,-0.40265 0.29515,-0.35563 0.37793,-0.34019 0.70886,0.13229 0.47981,0.68502 1.53041,0.68797 2.00834,0.006 l 0.37074,-0.52931 0.47902,0.52931 c 0.609,0.67294 1.24333,0.67294 1.85234,0 l 0.47901,-0.52931 0.37075,0.52931 c 0.47792,0.68234 1.52852,0.67939 2.00833,-0.006 0.33094,-0.47248 0.41371,-0.48792 0.70886,-0.13229 0.18379,0.22145 0.43865,0.40265 0.56635,0.40265 0.12771,0 0.23219,-2.02407 0.23219,-4.49792 v -4.49792 h 4.63021 4.63021 v 1.05834 1.05833 h -3.57188 -3.57187 v 9.525 9.525 h -7.40833 -7.40834 z",
    id: "path587"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPiezo);
export default __webpack_public_path__ + "static/media/map_piezo.c5605d03ec2611596f26e025a25ac93c.svg";
export { ForwardRef as ReactComponent };